/**
 * 认证 API
 */

import { api } from './client'
import type { User, LoginRequest, LoginResponse, ChangePasswordRequest } from '@/types'

export const authApi = {
  /** 登录 */
  login(data: LoginRequest): Promise<LoginResponse> {
    return api.post<LoginResponse>('/auth/login', data)
  },

  /** 登出 */
  logout(): Promise<void> {
    return api.post<void>('/auth/logout')
  },

  /** 获取当前用户信息 */
  me(): Promise<User> {
    return api.get<User>('/auth/me')
  },

  /** 修改密码 */
  changePassword(data: ChangePasswordRequest): Promise<void> {
    return api.post<void>('/auth/change-password', data)
  }
}
